import React, { useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export const DepositEditor = ({ item, authFetch, onSaved }) => {
  const [amount, setAmount] = useState(String(item.deposit ?? 0));
  const [busy, setBusy] = useState(false);
  const changed = String(item.deposit ?? 0) !== amount;
  const save = async () => {
    const n = parseInt(amount, 10);
    if (Number.isNaN(n) || n < 0) { toast.error('Enter a valid amount.'); return; }
    setBusy(true);
    try {
      await authFetch('patch', `/admin/estimate/${item.id}/deposit`, { amount: n });
      toast.success(`Deposit received set to £${n}.`);
      onSaved?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't save deposit."); } finally { setBusy(false); }
  };
  return (
    <div className="flex items-center gap-1.5 text-xs text-slate-500" data-testid="cal-deposit-editor">
      <span>{item.deposit_claimed_at ? 'Deposit received' : 'Deposit'} £</span>
      <input type="number" min="0" value={amount} onChange={(e) => setAmount(e.target.value)} className="w-20 h-8 rounded border border-slate-200 px-2 text-sm font-bold text-[color:var(--mv-navy)]" data-testid="cal-deposit-amount" />
      {!changed && <span className="text-[10px] text-slate-400">edit if they paid a different amount</span>}
      {changed && (
        <button type="button" onClick={save} disabled={busy} className="h-8 px-2.5 rounded bg-[color:var(--mv-navy)] text-white font-bold inline-flex items-center gap-1" data-testid="cal-deposit-save">
          {busy && <Loader2 className="w-3 h-3 animate-spin" />}Save
        </button>
      )}
    </div>
  );
};
